import en from './en';
import sp from './sp';
import enAttr from './en/en-att'
import spAttr from './sp/sp-att'

export default {
    en: {
        message: en,
        attributes: enAttr,
        currency: {
            style: 'currency', currency: 'USD', maximumFractionDigits: '2'
        }
    },
    sp: {
        message: sp,
        attributes: spAttr,
        currency: {
            style: 'currency', currency: 'USD', maximumFractionDigits: '2'
        }
    },
}